import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { useAuth, getLoggedInUserData } from '../../context/AuthContext';

// Context Files
import { useMenu } from '../../context/MenuContext';
import { ThemeMode } from '../../context/ThemeMode';

// Icons & imgeas common files
import Icons from '../../components/icons'

// Components
import Logo from '../../components/Logo';
import Sidemenu from './Sidemenu';
import Switche from '../../components/commonfield/Switche';
import UserInfoBx from '../../components/UserInfoBx';

export default function Header() {
  const [user, setUser] = useState('')
  const { state, dispatch } = useAuth();
  const [userLoggedIn, setUserLoggedIn] = useState(false);
  const navigate = useNavigate();

  // --- ---
  const { isActive, toggleMenu, isMinActive, toggleMinMenu } = useMenu();
  // --- ---

  // --- ---
  const { isDarkMode, toggleTheme } = ThemeMode();
  // --- ---

  useEffect(() => {
    const loggedInUser = getLoggedInUserData();
    const isUserLoggedIn = !!loggedInUser;
    if (isUserLoggedIn) {
      setUserLoggedIn(true);
      setUser(loggedInUser);
    } else {
      navigate('/');
    }
  }, [state.userData]);

  return (
    <>
      <header className={`custom-header ${isMinActive ? "cw-smb-mini" : "" }`}>
        <div className="ch-inner">
          <div className="ch-left">
            <div className="smb-min-btn" onClick={toggleMinMenu}>
              <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.67815 8.84612C4.67815 8.84612 0.83204 6.01347 0.832031 4.99993C0.832022 3.9864 4.67818 1.15381 4.67818 1.15381" stroke="#EEE7FF" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9.16448 8.84612C9.16448 8.84612 5.31837 6.01347 5.31836 4.99993C5.31835 3.9864 9.16451 1.15381 9.16451 1.15381" stroke="#EEE7FF" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div className={`menu-icon-bx ${isActive ? 'active' : ''}`} onClick={toggleMenu}>
              <span></span>
              <span></span>
              <span></span>
            </div>
            <Logo to="/home" className="ch-logo-bx" />
          </div>
          <div className="ch-right">

            <div className="cr-theme-btn d-none">
              <div className="cr-tb-lable">{isDarkMode ? "Dark mode" : "Light mode"}</div>
              <Switche
                onClick={toggleTheme}
                className={isDarkMode ? "active" : ""}
                icon={isDarkMode ? <Icons.MoonSvg /> : <Icons.SunSvg />}
              />
            </div>

            {/* <div onClick={toggleTheme} title={isDarkMode ? "Light mode" : "Dark mode"} className="cr-icons-link cr-theme-btn">
              <Icons.QuestionsSvg />
            </div> */}

            {/* <div className="cr-icons-link cr-il-noti">
              <Icons.NotificationsSvg />
              <div className="cr-num"></div>
            </div> */}

            <UserInfoBx className="cr-uib" />

          </div>
        </div>
      </header>

      <Sidemenu />
    </>
  )
}
